import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import Login from "./form/Login";
import Button from "../../ui/Button";
import Registration from "./form/Registration";
import RegistrationProvider from "./form/RegistrationProvider";

const ProvideServicesTab = () => {
    return (

        <RegistrationProvider>
            {/*<Button className={'w-100 justify-center btn-revert'}*/}
            {/*        onClick={()=>setIsLogin(true)}><>{t('login_page.login')}</>*/}
            {/*</Button>*/}
        </RegistrationProvider>

    );
};

export default ProvideServicesTab;